import { AsyncPipe } from '@angular/common';
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Product, TranslatePipe } from '@spartacus/core';
import { CurrentProductService } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { switchMap, take, tap } from 'rxjs/operators';
import { ShimanoPromotion } from 'src/app/model/product.model';
import { ShimanoCountryService } from 'src/app/service/country/shimano-country.service';
import {
  GoogleTagManagerEvent,
  GoogleTagManagerProductListName,
  GoogleTagManagerService,
} from 'src/app/service/googletagmanager/google-tag-manager.service';
import { ShimanoLanguageService } from 'src/app/service/language/shimano-language.service';
import { PDP_PROMOTION, TooltipIconService } from 'src/app/service/tooltip-icon/tooltip-icon.service';
import { CurrentBusinessType } from 'src/app/utility/current-businesstype';
import { TooltipIconComponent } from '../../tooltip-icon/tooltip-icon.component';
import { TooltipTextComponent } from '../../tooltip-text/tooltip-text.component';

@Component({
  selector: 'app-product-promotions',
  templateUrl: './product-promotions.component.html',
  styleUrls: ['./product-promotions.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [TooltipTextComponent, TooltipIconComponent, AsyncPipe, TranslatePipe],
})
export class ProductPromotionsComponent implements OnInit {
  product$: Observable<Product> = this.currentProductService.getProduct().pipe(
    tap((product) => {
      if (product && product.potentialPromotions && product.potentialPromotions.length) {
        this.gtmPromoView(product.potentialPromotions, product);
      }
    })
  );

  tooltipIconConfig$: Observable<any>;
  gtmbusinessType: string = this.currentBusinesstype.getBusinessType();
  affiliation = `/${this.gtmbusinessType}/${this.gtmActiveCountry}/${this.activeLanguage}`;

  @Input() fromGrid = false;
  @Input() promProductsFromGrid$: Observable<Product>;

  constructor(
    protected currentProductService: CurrentProductService,
    private gtmService: GoogleTagManagerService,
    private countryService: ShimanoCountryService,
    private languageService: ShimanoLanguageService,
    private tooltipIconService: TooltipIconService,
    private currentBusinesstype: CurrentBusinessType
  ) {}

  ngOnInit(): void {
    this.tooltipIconConfig$ = this.activeCountry$.pipe(
      take(1),
      switchMap((activeCountry) => this.tooltipIconService.getTooltipIconConfig(activeCountry, PDP_PROMOTION))
    );
  }

  get gtmActiveCountry(): string {
    let activeCountry: string;
    this.countryService.getActive().subscribe((country) => (activeCountry = country));
    return activeCountry;
  }

  get activeLanguage(): string {
    let activeLanguage: string;
    this.languageService.getActive().subscribe((lang) => (activeLanguage = lang));
    return activeLanguage;
  }

  concatText(promo: string | any[], stat: any): string {
    if (promo.length > 34) {
      var fullTooltip = `<span>${promo}</br></br>${stat}</span>`;
      return fullTooltip;
    } else {
      return `${stat}`;
    }
  }

  gtmPromoView(promotions: ShimanoPromotion[], product: any) {
    if (promotions.length) {
      promotions.forEach((promo, index) => {
        if (promo) {
          this.gtmService.pushTag({
            ecommerce: null,
            search_term: '',
            results_page: '',
            affiliation: '',
            content_type: '',
            content_id: '',
            content_name: '',
          });
          this.gtmService.pushTag({
            event: GoogleTagManagerEvent.PROMO_VIEW,
            ecommerce: {
              promotion_id: promo.code,
              promotion_name: promo.description,
              creative_slot: GoogleTagManagerProductListName.PDP,
              items: [
                {
                  item_id: product.code,
                  item_name: product.name,
                  affiliation: this.affiliation,
                  index: 0,
                  item_brand: product?.brand?.name,
                  price: product.basePrice.formattedValue,
                },
              ],
            },
          });
        }
      });
    }
  }

  get activeCountry$(): Observable<string> {
    return this.countryService.getActive();
  }

  get activeLanguage$(): Observable<string> {
    return this.languageService.getActive();
  }
}
